var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isErrorHTTP, isSuccessHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { AsyncContainer } from 'badphraim/core/AsyncContainer';
export class BoostInvoiceController {
    constructor(host) {
        this.isLoading = false;
        this.host = host;
        host.addController(this);
    }
    hostConnected() {
        this.loadingPromise = undefined;
    }
    setInvoice(invoice) {
        var _a;
        this.invoice = invoice;
        (_a = this.onInvoiceChange) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    setInvoiceId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!id) {
                return;
            }
            this.invoiceId = id;
            yield this.loadInvoice();
        });
    }
    get getInvoice() {
        return this.invoice;
    }
    waitForInvoiceLoaded() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoading && this.loadingPromise) {
                yield this.loadingPromise.getValue();
            }
        });
    }
    isInvoicePaid() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.waitForInvoiceLoaded();
            return Boolean(this.invoice && this.invoice.invoice.rest === 0);
        });
    }
    loadInvoice() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.invoiceId) {
                return;
            }
            if (this.loadingPromise) {
                this.loadingPromise.reject('Invoice load was cancelled/overwritten.');
                this.loadingPromise = undefined;
            }
            const loadingPromise = new AsyncContainer();
            this.loadingPromise = loadingPromise;
            this.isLoading = true;
            const invoiceRequest = yield MembersignupAPI.getV1BoostsignupInvoiceUsingInvoiceId(this.invoiceId);
            if (isSuccessHTTP(invoiceRequest)) {
                this.invoice = invoiceRequest;
                loadingPromise.setValue();
            }
            else if (isErrorHTTP(invoiceRequest)) {
                this.loadingPromise.reject('Invoice request error');
            }
            this.host.requestUpdate();
        });
    }
}
